import { Col, Container, Form, Row } from 'react-bootstrap';

const contactInfo = [
    {
        id: 1,
        icon: 'ri-map-pin-2-line',
        title: 'Office Location',
        content: '21 Innovation Avenue, Suite 403\nBusiness Park, Sector 18B\nMumbai, Maharashtra 400072, India'
    },
    {
        id: 2,
        icon: 'ri-phone-line',
        title: 'Phone Number',
        content: '+91 01-000-999-333'
    },
    {
        id: 3,
        icon: 'ri-mail-line',
        title: 'Email Address',
        content: 'digital@strivoagency.com'
    }
]

const serviceOptions = [
    { value: 'seo', label: 'Search Engine Optimization' },
    { value: 'ppc', label: 'Pay-Per-Click Advertising' },
    { value: 'social', label: 'Social Media Marketing' },
    { value: 'email', label: 'Email Marketing' },
    { value: 'content', label: 'Content Marketing' },
    { value: 'analytics', label: 'Analytics & Reporting' }
]

const Contact = () => {
    const handleSubmit = (e) => {
        e.preventDefault()
        // Handle form submission logic here
        console.log('Form submitted')
    }

    return (
        <section className="section-lg bg-light" id="contactus">
            <Container>
                <Row className="text-center mb-5">
                    <Col lg={8} className="mx-auto">
                        <span className="badge bg-success-subtle text-success fw-semibold mb-3">Get In Touch</span>
                        <h2 className="display-6 fw-bold mb-3">Ready to Grow Your Business?</h2>
                        <p className="lead text-secondary">Contact us today for a free consultation and discover how our digital marketing services can help you achieve your business goals.</p>
                    </Col>
                </Row>
                <Row className="g-4">
                    <Col lg={5}>
                        <div className="card border-0 shadow-sm contact-card h-100 rounded-4">
                            <div className="card-body p-4">
                                <h4 className="fw-bold mb-4 text-success">Contact Information</h4>
                                {contactInfo.map((info, index) => (
                                    <div key={info.id} className={`d-flex align-items-start${index < contactInfo.length - 1 ? ' mb-4' : ''}`}>
                                        <div className="icon-wrapper bg-success bg-opacity-10 text-white rounded-circle d-flex align-items-center justify-content-center me-3">
                                            <i className={`${info.icon} fs-4`}></i>
                                        </div>
                                        <div>
                                            <h6 className="fw-semibold mb-1">{info.title}</h6>
                                            <p className="text-secondary mb-0 small" style={{ whiteSpace: 'pre-line' }}>
                                                {info.content}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>
                    <Col lg={7}>
                        <div className="card border-0 shadow-sm h-100 rounded-4">
                            <div className="card-body p-4">
                                <h4 className="fw-bold text-success mb-4">Send Us a Message</h4>
                                <Form className="contactus-form" onSubmit={handleSubmit}>
                                    <Row className="g-4">
                                        <Col md={6}>
                                            <Form.Label htmlFor="fullName" className="fw-semibold">Full Name</Form.Label>
                                            <Form.Control type="text" className="rounded-3 shadow-sm" id="fullName" placeholder="Your name"/>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Label htmlFor="emailAddress" className="fw-semibold">Email Address</Form.Label>
                                            <Form.Control type="email" className="rounded-3 shadow-sm" id="emailAddress" placeholder="Your email"/>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Label htmlFor="phoneNumber" className="fw-semibold">Phone Number</Form.Label>
                                            <Form.Control type="tel" className="rounded-3 shadow-sm" id="phoneNumber" placeholder="Your phone"/>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Label htmlFor="companyName" className="fw-semibold">Company Name</Form.Label>
                                            <Form.Control type="text" className="rounded-3 shadow-sm" id="companyName" placeholder="Your company"/>
                                        </Col>

                                        <Col xs={12}>
                                            <Form.Label htmlFor="serviceInterest" className="fw-semibold">Service of Interest</Form.Label>
                                            <Form.Select className="rounded-3 shadow-sm" id="serviceInterest" defaultValue="">
                                                <option value="" disabled>Select a service</option>
                                                {serviceOptions.map((service) => (
                                                    <option key={service.value} value={service.value}>
                                                        {service.label}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col>

                                        <Col xs={12}>
                                            <Form.Label htmlFor="messageContent" className="fw-semibold">Message</Form.Label>
                                            <Form.Control as="textarea" className="rounded-3 shadow-sm" id="messageContent" rows={4} placeholder="Tell us about your project"/>
                                        </Col>

                                        <Col xs={12} className="text-center mt-3">
                                            <button type="submit" className="btn btn-success px-5 rounded-pill shadow-sm">
                                                <i className="ri-send-plane-line me-2"></i> Send Message
                                            </button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Contact;
